import type { ReactElement } from 'react';
import { useSearchParams } from 'react-router';
import { parseMyOrdersPage } from '@/shared/lib';
import { SitePageShell } from '@/shared/ui';
import { MyOrderList } from '@/widgets/my-order-list';
import { MyPageHeader } from '@/widgets/my-page-header';
import { MyPageNav } from '@/widgets/my-page-nav';
import { SiteFooter } from '@/widgets/site-footer';
import { SiteHeader } from '@/widgets/site-header';

/**
 * 마이페이지 내 주문 목록(/my/orders, 주문 설계 §8-2) — 내 견적 목록과 같은 틀(큰 "My Page" 머리 아래 왼쪽(좁은 화면은 위)
 * 메뉴와 목록). 주소의 page 쿼리로 목록을 읽고, 페이지 이동은 다른 검색 매개변수를 보존한 채 그 쿼리만 바꾼다.
 */
export const MyOrdersPage = (): ReactElement => {
  const [params, setParams] = useSearchParams();
  const page = parseMyOrdersPage(params);

  const changePage = (next: number): void => {
    const search = new URLSearchParams(params);
    if (next > 1) search.set('page', String(next));
    else search.delete('page');
    setParams(search);
  };

  return (
    <SitePageShell header={<SiteHeader />} footer={<SiteFooter />} className="pt-12 sm:pt-16">
      <MyPageHeader />
      <div className="mt-8 grid gap-10 sm:mt-12 lg:grid-cols-[13rem_minmax(0,1fr)] lg:gap-16 xl:grid-cols-[15rem_minmax(0,1fr)] xl:gap-20">
        <MyPageNav activeId="orders" />
        <MyOrderList page={page} onPageChange={changePage} />
      </div>
    </SitePageShell>
  );
};
